import { Permission } from '../../Models/permission';

export const PERMISSIONS: Permission[] = [

];